import axios from '@axios'
import ApiRouteProvider from '../route'
import {objectToGETParams} from '../route'

function getBasePath() {
    return ApiRouteProvider.getBaseUrl() + '/research/review/processes'
}

export default {
    getProcesses(filters = {}, page = 1, perPage = 20) {
        const query = objectToGETParams({
            ...filters,
            page,
            perPage,
        })

        return axios.get(getBasePath() + (query ? '?' + query : ''))
    },

    getProcess(id) {
        return axios.get(getBasePath() + '/' + id)
    },

    updateItem(processId, itemId, payload) {
        return axios.patch(getBasePath() + '/' + processId + '/items/' + itemId, payload)
    },

    completeProcess(processId, payload) {
        return axios.post(getBasePath() + '/' + processId + '/complete', payload)
    },

    resolveFileDownloadUrl(fileReferenceId) {
        return axios.get(
            ApiRouteProvider.getBaseUrl()
            + '/research/review/files/'
            + encodeURIComponent(fileReferenceId)
            + '/download-url'
        )
    },

    downloadFileByUrl(url) {
        return axios.get(url, {
            responseType: 'arraybuffer',
        })
    },
}
